import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "preview-header-content" }
const _hoisted_2 = { class: "preview-header-top" }
const _hoisted_3 = { class: "preview-category" }
const _hoisted_4 = { class: "preview-title" }
const _hoisted_5 = { class: "preview-header-actions" }
const _hoisted_6 = {
  class: "drag-handle",
  title: "Drag to move"
}
const _hoisted_7 = { class: "preview-body" }
const _hoisted_8 = { class: "preview-section" }
const _hoisted_9 = { class: "preview-label" }
const _hoisted_10 = { class: "preview-subject-text" }
const _hoisted_11 = {
  key: 0,
  class: "preview-section"
}
const _hoisted_12 = { class: "preview-label" }
const _hoisted_13 = { class: "preview-shortcut-content" }
const _hoisted_14 = { class: "shortcut-text" }
const _hoisted_15 = { class: "preview-section" }
const _hoisted_16 = { class: "preview-label" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "preview-footer" }
const _hoisted_19 = { class: "preview-stats" }
const _hoisted_20 = { class: "copy-count" }
const _hoisted_21 = { class: "preview-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["preview-modal-overlay", { 'dragging-active': !_ctx.isInitialPosition }])
          }, [
            _createElementVNode("div", {
              ref: "modalRef",
              class: _normalizeClass(["preview-modal", { 'is-dragging': _ctx.isDragging }]),
              style: _normalizeStyle(_ctx.modalStyle),
              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
              onMousedown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args))),
              onTouchstart: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args)))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["preview-header", { draggable: true }])
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getCategoryLabel(_ctx.template?.category)), 1)
                  ]),
                  _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.template?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_Icon, {
                      icon: "mdi:drag",
                      width: "16",
                      height: "16"
                    })
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-close-preview",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                  }, [
                    _createVNode(_component_Icon, {
                      icon: "mdi:close",
                      width: "18",
                      height: "18"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Icon, {
                      icon: "mdi:email-outline",
                      width: "12",
                      height: "12"
                    }),
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "Subject:", -1))
                  ]),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.template?.subject), 1)
                ]),
                (_ctx.template?.shortcut)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_Icon, {
                          icon: "mdi:keyboard",
                          width: "12",
                          height: "12"
                        }),
                        _cache[10] || (_cache[10] = _createElementVNode("span", null, "Shortcut:", -1))
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.template.shortcut), 1),
                        _createVNode(_component_Icon, {
                          icon: "mdi:content-copy",
                          width: "14",
                          height: "14",
                          class: "copy-icon",
                          onClick: _withModifiers(_ctx.copyShortcut, ["stop"]),
                          title: "Copy Shortcut"
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_Icon, {
                      icon: "mdi:text-box-outline",
                      width: "12",
                      height: "12"
                    }),
                    _cache[11] || (_cache[11] = _createElementVNode("span", null, "Content:", -1))
                  ]),
                  _createElementVNode("div", {
                    class: "preview-content-text",
                    innerHTML: _ctx.template?.content
                  }, null, 8, _hoisted_17)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "preview-stat clickable positive",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.markPositive && _ctx.markPositive(...args)), ["stop"])),
                    title: "Mark Positive"
                  }, [
                    _createVNode(_component_Icon, {
                      icon: "mdi:thumb-up",
                      width: "14",
                      height: "14"
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.template?.positiveReplies || 0), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "preview-stat clickable negative",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.markNegative && _ctx.markNegative(...args)), ["stop"])),
                    title: "Mark Negative"
                  }, [
                    _createVNode(_component_Icon, {
                      icon: "mdi:thumb-down",
                      width: "14",
                      height: "14"
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.template?.negativeReplies || 0), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "btn-copy-template",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyTemplate && _ctx.copyTemplate(...args)), ["stop"])),
                    title: "Copy Template"
                  }, [
                    _createVNode(_component_Icon, {
                      icon: "mdi:content-copy",
                      width: "14",
                      height: "14"
                    }),
                    _cache[12] || (_cache[12] = _createElementVNode("span", null, "Copy", -1)),
                    _createElementVNode("span", _hoisted_20, "(" + _toDisplayString(_ctx.template?.copied || 0) + ")", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "btn-edit",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editTemplate && _ctx.editTemplate(...args)), ["stop"])),
                    title: "Edit Template"
                  }, [
                    _createVNode(_component_Icon, {
                      icon: "mdi:pencil",
                      width: "14",
                      height: "14"
                    })
                  ]),
                  _createElementVNode("button", {
                    class: "btn-delete",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteTemplate && _ctx.deleteTemplate(...args)), ["stop"])),
                    title: "Delete Template"
                  }, [
                    _createVNode(_component_Icon, {
                      icon: "mdi:delete",
                      width: "14",
                      height: "14"
                    })
                  ])
                ])
              ])
            ], 38)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}